import { render, staticRenderFns } from "./VlBottomFilterButton.vue?vue&type=template&id=5f1b7bb8&scoped=true&"
import script from "./VlBottomFilterButton.vue?vue&type=script&lang=js&"
export * from "./VlBottomFilterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b7bb8",
  null
  
)

export default component.exports